import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../.././api/api';
import arrowleft from '../../assets/arrowleft.png';
import redmic from '../../assets/redmic.png';
import copydark from '../../assets/copy.svg';
import printdark from '../../assets/printicon.svg';
import Copyall from '../../assets/bi_copy.svg';
import { Backdrop, CircularProgress, Snackbar } from '@mui/material';
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import ArchiveRecordingScreen from './archiveRecording';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { faTrash, faSave, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import ToastModal from 'alerts/recordingscreen/toastmodal';
import "react-quill/dist/quill.snow.css";
import adveditpng from '../../assets/advediting.png'
import MenuIcon from '@mui/icons-material/Menu';
import GridViewIcon from '@mui/icons-material/GridView';
import DangerousIcon from '@mui/icons-material/Dangerous';
import ToastMessage from 'utils/muialerts/simplealert';
import expandicon from '../../assets/expand.png'
import icroundmic from '../../assets/ic_round-mic.svg'
import { Expand } from '@mui/icons-material';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import SplitscreenOutlinedIcon from '@mui/icons-material/SplitscreenOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MicIcon from '@mui/icons-material/Mic';
import IndividualRecording from './indrecording';
import useModalStore from 'zustand/zustandstore';
import CloseIcon from '@mui/icons-material/Close';
import ShareModal from 'basic/modals/share';
import ArcheiveStreaming from 'basic/archeivestreaming/archeiveStreaming';
import RecordRTC, { StereoAudioRecorder } from 'recordrtc';
import ExitModal from 'streaming/exitmodal';
import DeleteConfirmation from 'streaming/deleteconfirmation';
import ReactQuill from 'react-quill';
import { formatToText } from 'utils/jsonhandlers/jsontohtml';
import useAudioRecorder from 'streaming/audiorecorderhook';
import { saveAudioInIndexDB } from 'offlinestreaming/offlineBlobHandler';
import TranscriptModal from 'basic/modals/transcriptmodal';
import ShowPdf from 'pages/templatecreation/showpdf';
import PdfRender from './pdfrender';
const Editscreen = () => {
  const excludedKeys = ["Date", "Patient_ID", "Patient_Name", "Visit_Summary", "Appointment_Summary"];
  const [jsonData, setJsonData] = useState([])
  const [isRecording, setIsRecording] = useState(false);
  const [indisRecording, setIndIsRecording] = useState(false)
  const [isdeletedaudio, setIsdelted] = useState(false)
  const [selectedCard, setSelectedCard] = useState('')
  const [sectiondata, setSectionData] = useState({})
  const percentage = 100;
  const circleStyle = {
    background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${percentage * 3.6}deg)`,
  };
  const [summaryjson, setSummaryJson] = useState([])
  const [pdffile, setPdffile] = useState()
  const [userr, setUser] = useState({})
  const [popup, setPopUp] = useState(false)
  const [ispdfshow, setIspdfShow] = useState(false)
  const streamname = useRef()
  const [isbuttonloading, setIsButtonLoading] = useState(false)
  const [indisDeletedAudio, setIndIsDeletedAudio] = useState(false)
  const [open, setOpen] = useState(false);
  const [alertmessage, setAlertMessage] = useState('');
  const [view, setView] = useState(2)
  const [severity, setSeverity] = useState('success');
  const [isLoading, setIsLoading] = useState(false)
  const [pdfblob, setPdfBlob] = useState('')
  const mydata = useModalStore();
  const [config, setConfig] = useState({})
  const [configuser, setConfiguser] = useState()
  const [audiofile, setAudiofile] = useState()
  const [isSharemodal, setIsShareModal] = useState(false)
  const [toast, setToast] = useState(false)
  const [isExpanded, setIsexpanded] = useState(false)
  const [expandedRows, setExpandedRows] = useState({});
  const [rowSizes, setRowSizes] = useState({});
  const [data, setData] = useState({});
  const [recordingField, setRecordingField] = useState('')
  const [isIndRecord, setIsIndRecord] = useState(false)
  const indref = useRef(null)
  const recordingfieldref = useRef('')
  const [fields, setFields] = useState({
    chiefcomplaint: '',
    hpi: '',
    ros: '',
    physicalexam: '',
    assessment: '',
    plan: ''
  });

  const [toastobject, setToastObject] = useState({
    icon: DangerousIcon,
    text1: "Something Went Wrong",
    text2: ""

  })
  const navigate = useNavigate();
  const { id, name } = useParams();
  const [copyFeedback, setCopyFeedback] = useState('')
  const [streamfilename, setStreamfilename] = useState('')
  const [deleteconfirmationModal, setDeleteConfirmationModal] = useState(false)
  const [isExitModal, setIsexitModal] = useState(false)
  const [elapsedTime, setElapsedTime] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const recorderRef = useRef(null);
  const [mycard, setMyCard] = useState('')
  const token = sessionStorage.getItem("auth");
  const [transciptFile, setTranscriptFile] = useState('')
  const [showtranscript, setShowTranscript] = useState(false)
  const audioStreamRef = useRef(null);
  const startTimeRef = useRef(null); // Tracks the timer's start/resume time
  const timerRef = useRef(null);
  const pausedref = useRef(false)
  const ismanualstop = useRef(false)
  const ismanualrecordstart = useRef(false)
  const wsRef = useRef(null)
  const blocker = useRef(false)
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const onSaving = (blob) => {
    if (blob && blob.type.startsWith("audio/")) {
      console.log("Valid audio blob:", blob);
      // Call the function to submit the audio blob
      if (blocker.current) {
        return
      }
      submitAudioBlobManually(blob);
    } else {
      console.error("Invalid blob. Not an audio file.");
    }

  };
  const { manualrecord, stopmanualRecording, pausemanualRecording, resumemanualRecording } = useAudioRecorder(onSaving);
  const handlealertClick = (message, severity) => {
    setAlertMessage(message);
    setSeverity(severity);
    setOpen(true);
  };
  const fetchData = async () => {
    setIsLoading(true)
    setFields({
      chiefcomplaint: '',
      hpi: '',
      ros: '',
      physicalexam: '',
      assessment: '',
      plan: ''
    })
    try {
      const response = await api.get(`/v1/recording/note/${id}/get`);
      if (response.status === 200) {
        const initialData = response.data[0]
        setData(initialData);
        const notesArray = Object.keys(initialData?.note_json || {})
          .filter(key => !excludedKeys.includes(key))
          .map((key, index) => ({
            id: index + 1,
            label: key.replace(/_/g, " "),
            key: key,
            title: key,
            value: initialData.note_json[key],
            placeholder: key,
          }));
        const order = [
          "chief_complaint",
          "physical_examination",
          "review_of_systems",
          "hpi",
          "assessment",
          "plan",
          "patient_directions",

          "allergies",
          "family_history",
          "medical_history",

          "social_history",
          "surgical_history",
          "doctor_instructions"
        ];

        const sortedData = Array.isArray(notesArray)
          ? order.map(key =>
            notesArray.find(item => item.key.toLowerCase() === key.toLowerCase())
          ).filter(Boolean)
          : [];


        const transformKeysToLowercase = (obj) => {
          if (!obj || typeof obj !== 'object') return obj;

          return Object.keys(obj).reduce((acc, key) => {
            acc[key.toLowerCase()] = obj[key];
            return acc;
          }, {});
        };

        setSummaryJson(transformKeysToLowercase(initialData?.summary_json || {}));

        // setSummaryJson(initialData?.summary_json||{})
        console.log(sortedData, 'Sorted')
        setJsonData(sortedData || [])

        setConfiguser(response.data[0])
        setConfig(response.data[0].config)
        setFields(initialData?.note_json)
        const user = await api.get(`/v1/appointments/get/${response.data[0].config?.appointmentid}`)
        if (user.status === 200) {
          setUser(user?.data)
        }
      }
    } catch (error) {
      console.error('Error fetching data', error);
    } finally {
      setIsLoading(false)
    }

  };
  const fetchuserdata = async () => {
    try {

    } catch (error) {

    }
  }

  useEffect(() => {
    fetchData();
    fetchuserdata()
  }, [id]);
  const submitdata = async (payload, text, fieldname) => {
    const a = fieldname;
    const b = text;
    const obj = { [a]: b };
    const transformedData = {
      "context_dict": obj
    };
    setIsLoading(true);

    try {
      const response = await api.put('/v1/recording/category/update', {
        ...transformedData,
        file_name: data.audiolink

      });
      fetchData()
      // Handle response here if needed
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }

  };
  const submitAudioBlobManually = async (blob) => {

    if (isdeletedaudio) {
      setAudiofile('')
      handlealertClick('Recording has been Deleted', 'error')
    } else {

      try {
        let modifiedcategory = 'combine'
        console.log(isIndRecord, 'isind')

        if (indref.current) {
          modifiedcategory = recordingfieldref.current
        }



        console.log("inserting into index db ...")
        saveAudioInIndexDB({
          file: blob, practiceid: config.practiceid, departmentid: config.departmentid
          , patientid: config.patientid, notes: 'testing data', tags: 'tagsdata',
          patientname: name, templatename: config?.template_name || null, role: mydata.usertype,
          filename: streamname.current, appointmentid: "", category: modifiedcategory,
          appointmentid: config?.appointmentid || null, rowid: id, status: "edit", streamingfilename: data.audiolink, userid: configuser?.user_id
        })

      } catch (error) {
        console.error('Error uploading audio:', error);
      } finally {

        setIsexitModal(false)
      }

    }


  }

  const handleSignoff = async () => {
    if (isbuttonloading) return
    setIsButtonLoading(true)
    try {
      const response = await api.put('/v1/document/sign-off', { "document_name": data?.audiolink })
      if (response.status === 200) {
        handlealertClick('Signed!');

        // setSeverity('success'); // Change severity as needed

        setOpen(true);
        setTimeout(() => {
          navigate('/landing', { replace: true });
        }, 1000);
      } else if (response.status === 201) {
        // setMessage(response.message);
        // setSeverity('info'); // Change severity as needed
        handlealertClick(response.message)
        setOpen(true);
      }
    } catch (error) {

      handlealertClick('something went wrong', 'error')
      // setMessage('something went wrong');
      // setSeverity('error'); // Change severity as needed
      setOpen(true);
    } finally {
      setIsButtonLoading(false)
      fetchData()
    }

  }
  const handletranscript = async () => {
    setIsLoading(true)

    try {
      const response = await api.get(`/v1/trascript/${data.audiolink}`);
      if (response.status === 200) {
        let transcript = response.data.trim();
        if (transcript.startsWith('"') && transcript.endsWith('"')) {
          transcript = transcript.slice(1, -1);
        }
        setTranscriptFile(transcript);
        setShowTranscript(true);
      } else {
        handlealertClick(response.message, 'info')
      }


    } catch (error) {
      console.log(error)
      handlealertClick('something went wrong', 'error')
    } finally {
      setIsLoading(false)
    }

  }
  const handleEditTranscript = async (text) => {
    try {
      setIsLoading(true)
      const response = await api.put(`/v1/transcript`, {
        "audio_link": data.audiolink,
        "transcript": text
      })
      if (response.status === 200) {
        handlealertClick(response.message, 'success')
      } else {
        handlealertClick(response.message, 'info')

      }

    } catch (error) {
      console.log(error)
      handlealertClick('something went wrong', 'error')
    } finally {
      setIsLoading(false)
      handletranscript()
    }


  }
  const handlepdf = async (value, card) => {

    if (card.transcriptionstatus == 'Processing') {
      setAlertMessage('Update in process. Hold on!');
      setSeverity('info'); // Change severity as needed
      setOpen(true);
      return
    }

    try {
      // Trigger loading spinner
      setIsLoading(true);

      const uniqueParam = new Date().getTime(); // or use a random number: Math.random()

      // Fetch the PDF from the server with a unique parameter to prevent caching
      const response = await api.get(`/v1/documents/PDF/${value}?_=${uniqueParam}`, {
        responseType: "blob", // Ensure response type is 'blob' for binary data
      });
      // Fetch the PDF from the server
      // const response = await api.get(`/v1/documents/PDF/${value}`, {
      //   responseType: "blob", // Ensure response type is 'blob' for binary data
      // });
      // // Create a Blob from the PDF data
      const pdfBlob = new Blob([response], { type: "application/pdf" });

      // Generate a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setMyCard(card)
      setPdffile(pdfBlob)
      // Open the generated URL in a new tab
      //window.open(pdfUrl, "_blank");

    } catch (error) {
      console.error("Error fetching the PDF:", error);
    } finally {
      // Turn off loading spinner
      setIsLoading(false);
      setIspdfShow(true)
    }
  };
  const copyToClipboard = (htmlText) => {
    // Create a temporary div to parse HTML
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlText;
    tempElement.querySelectorAll("br")?.forEach(br => br.replaceWith("\n"));
    // Extract plain text without HTML tags
    const plainText = tempElement.innerText || tempElement.textContent;

    // Copy to clipboard
    navigator.clipboard.writeText(plainText)
      .then(() => {
        handlealertClick("Copied to clipboard!", "success");
      })
      .catch(err => {
        console.error("Failed to copy text: ", err);
      });
  };


  const handleFieldChange = (fieldName, value) => {
    setFields(prevFields => ({ ...prevFields, [fieldName]: value }));
  };

  const handleSaveIconClick = (fieldName) => {
    const fieldValue = fields[fieldName];
    const dataToSubmit = {
      [fieldName]: fieldValue,
      category: fieldName
    };
    submitdata(dataToSubmit, fieldValue, fieldName);
    setPopUp(false)
  };


  const handleSaveButtonClick = async () => {
    if (data.transcriptionstatus === 'Processing') {
      setAlertMessage('Update in process. Hold on!');
      setSeverity('info'); // Change severity as needed
      setOpen(true);
      return;
    }

    const changedFields = {};
    for (const key in fields) {
      if (fields[key] !== data[key]) {
        changedFields[key] = fields[key];
      }
    }
    const transformedData = {
      context_dict: changedFields // Assigning changedFields directly
    };
    setIsLoading(true);
    console.log(typeof (transformedData.context_dict))
    if (Object.keys(transformedData.context_dict).length === 0) {
      setIsLoading(false)
      handlealertClick('No Updated Data Found', 'error')

      return
    }
    try {

      const response = await api.put('/v1/recording/category/update', {
        ...transformedData,
        file_name: data.audiolink

      });


      fetchData()
      // Handle response here if needed
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }

  };
  const submitIndAudio = async (blob) => {
    if (indisDeletedAudio) {
      setAudiofile('')
      handlealertClick('Recording has been Deleted', 'error')
      setIsIndRecord(false)
      setRecordingField('')
      setIndIsDeletedAudio(false)
      indref.current = false
    } else {
      setIsIndRecord(false)

      console.log(blob)
      try {
        const formData = new FormData();
        formData.append("file", blob);
        formData.append("departmentid", config.departmentid);
        formData.append("category", recordingField);
        formData.append("patientname", name);
        formData.append("patientid", config.patientid);
        formData.append("appointmentid", config.appointmentid);
        formData.append("notes", "testing data");
        formData.append("practiceid", config.practiceid);
        formData.append("filename", data.audiolink);
        formData.append("rowid", id);
        formData.append("tags", 'tagsdata');


        const response = await api.post('v1/ehr/recording/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        if (response.status == 200) {
          handlealertClick('Recording Has Been Uploaded');
          navigate(-1)

        } else {
          handlealertClick('Something Went Wrong', 'error');
        }

      } catch (error) {
        console.error('Error uploading audio:', error);
      } finally {
        setRecordingField('')
      }
    }
  }
  const submitAudio = async (blob) => {
    if (isdeletedaudio) {
      setAudiofile('')
      handlealertClick('Recording has been Deleted', 'error')
    } else {
      try {
        const formData = new FormData();
        formData.append("file", blob);
        formData.append("departmentid", config.departmentid);
        formData.append("category", "combine");
        formData.append("patientname", name);
        formData.append("patientid", config.patientid);
        formData.append("appointmentid", config.appointmentid);
        formData.append("notes", "testing data");
        formData.append("practiceid", config.practiceid);
        formData.append("filename", data.audiolink);
        formData.append("rowid", id);
        formData.append("tags", 'tagsdata');

        const response = await api.post('v1/ehr/recording/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        if (response.status == 200) {
          handlealertClick('Recording Has Been Uploaded');
          navigate(-1)

        } else {
          handlealertClick('Something Went Wrong', 'error');
        }

      } catch (error) {
        console.error('Error uploading audio:', error);
      }

    }
  }
  const handleCopyallText = () => {
    let textToCopy = '';

    function formatValue(key, value, indent = '') {
      if (Array.isArray(value)) {
        // Format array values as a list
        return `${key}:\n${value.map(item => `${indent}- ${formatValue('', item, indent + '  ')}`).join('\n')}`;
      } else if (typeof value === 'object' && value !== null) {
        // Format nested object properties recursively
        let formattedObject = `${key}:\n`;
        for (const subKey in value) {
          if (value.hasOwnProperty(subKey)) {
            formattedObject += `${indent}${formatValue(subKey, value[subKey], indent + '  ')}\n`;
          }
        }
        return formattedObject.trim();
      } else {
        // Strip HTML if value is a string
        const tempElement = document.createElement("div");
        tempElement.innerHTML = value;
        tempElement.querySelectorAll("br")?.forEach(br => br.replaceWith("\n"));
        const formattedValue = tempElement.innerText || tempElement.textContent;
        return `${key}: ${formattedValue}`;
      }
    }

    for (const key in fields) {
      if (fields.hasOwnProperty(key)) {
        textToCopy += `${formatValue(key, fields[key])}\n\n`;
      }
    }

    console.log(textToCopy);




    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        handlealertClick('Copied to Clipboard', 'success');
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
        handlealertClick('Something went wrong', 'error');
      });
  };

  const handleExpandClick = (key, text) => {
    console.log("Current Expanded Rows:", expandedRows); // Debug log
    console.log("Clicked Row Key:", key);

    setExpandedRows((prev) => {
      const newExpandedRows = {};
      // Loop through previous state to update expansion
      Object.keys(prev).forEach((k) => {
        newExpandedRows[k] = k === key ? !prev[k] : false; // Toggle clicked row
      });
      console.log("New Expanded Rows:", newExpandedRows); // Debug log for new state
      return newExpandedRows; // Return updated state
    });

    // Calculate new row size
    calculateRows(key, text);
  };
  const calculateRows = (key, text) => {
    const lineHeight = 20; // Approximate line height in pixels
    const maxHeight = 100; // Initial height in pixels
    // Calculate the number of lines based on the text length
    const rows = Math.ceil(text.length / (maxHeight / lineHeight)); // Adjusted calculrration
    const newSize = Math.max(rows, 1); // Ensure at least one row is displayed

    setRowSizes((prev) => ({
      ...prev,
      [key]: newSize, // Set the row size for the specific section
    }));

    return newSize; // Return the calculated size
  };

  const startRecording = async (category = 'combine') => {
    pausedref.current = false;
    try {
      const text = crypto.randomUUID();
      setStreamfilename(text)
      streamname.current = text
      const filename = data.audiolink;
      const practiceid = config.practiceid || "";
      const departmentid = config.departmentid || "";
      const templatename = config.template_name || null
      const appointmentid = config.appointmentid

      const tags = "Sample tags";
      const patientname = name;
      const isBusinessUser = mydata.usertype == 'BUSINESS';
      const patientid = config.patientid
      const notes = "testing data"
      const ws = new WebSocket(
        `wss://api.prd.brainymed.com/v2/bs/v1/recording/streaming?token=${token}&rowid=${id}&stream_filename=${text}&practiceid=${practiceid}&departmentid=${departmentid}&patientid=${patientid}&appointmentid=${appointmentid}&notes=${encodeURIComponent(
          notes
        )}&tags=${encodeURIComponent(tags)}&filename=${filename}&category=${category}&patientname=${encodeURIComponent(patientname)}&template_name=${encodeURIComponent(templatename)}`

      );

      wsRef.current = ws;

      ws.onopen = () => {

        console.log("WebSocket connection established.");
      };

      ws.onerror = (error) => {
        ismanualrecordstart.current = true
        manualrecord()
        console.error("WebSocket error:", error);


      };

      ws.onclose = () => {
        if (!ismanualstop.current) {
          ismanualrecordstart.current = true
          console.log('manual record initiated')
          manualrecord()


        }
        console.log("WebSocket connection closed.");
      };

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      audioStreamRef.current = stream;

      const recorder = new RecordRTC(stream, {
        type: "audio",
        recorderType: StereoAudioRecorder,
        mimeType: "audio/webm",
        timeSlice: 5000, // Send data every 5 seconds
        desiredSampRate: 48000,
        numberOfAudioChannels: 1,
        ondataavailable: async (blob) => {

          if (ws.readyState === WebSocket.OPEN && !pausedref.current) {
            try {

              const base64Data = await blobToBase64(blob);
              ws.send(base64Data);
            } catch (error) {
              console.error("Error converting blob to base64:", error);
            }
          }
        },
      });

      recorder.startRecording();
      recorderRef.current = recorder;

      setElapsedTime(0);
      startTimer();

      setIsPaused(false);
    } catch (error) {
      console.error("Error starting recording:", error);

    }
  };
  const startTimer = () => {
    startTimeRef.current = Date.now() - elapsedTime * 1000; // Adjust for any previously elapsed time
    timerRef.current = setInterval(() => {
      const timePassed = Math.floor((Date.now() - startTimeRef.current) / 1000);
      setElapsedTime(timePassed);
    }, 1000);
  };

  const stopTimer = () => {
    clearInterval(timerRef.current);
    timerRef.current = null;
  };

  const togglePause = () => {

    if (pausedref.current) {
      // Resume the timer
      pausedref.current = false
      setIsPaused(false)
      startTimer();
      if (ismanualrecordstart) {
        resumemanualRecording()
      }
    } else {
      // Pause the timer
      if (ismanualrecordstart) {
        pausemanualRecording()
      }
      pausedref.current = true
      setIsPaused(true)
      stopTimer();
    }

  };
  const stopRecording = () => {
    ismanualstop.current = true
    ismanualrecordstart.current = false
    if (recorderRef.current) {
      recorderRef.current.stopRecording(() => {
        recorderRef.current = null;
      });
    }

    if (audioStreamRef.current) {
      audioStreamRef.current.getTracks().forEach((track) => track.stop());
      audioStreamRef.current = null;
    }

    if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
      wsRef.current.close(1000, "Recording stopped by user");
    }

    stopTimer();
    setElapsedTime(0);
    setIsRecording(false)
    setIsIndRecord(false)
    setRecordingField('')
    handlealertClick('Recording Has Been Completed', 'success')
    setTimeout(() => {
      indref.current = false
      recordingfieldref.current = ''
      navigate("/landing");
    }, 1500);
  };
  const onExit = () => {
    if (ismanualrecordstart.current) {
      stopmanualRecording()
    }
    stopRecording()
    setIsexitModal(false)
  }
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => {
        resolve(reader.result.split(",")[1]);
      };
      reader.onerror = (error) => reject(error);
    });
  };
  const onDelete = async () => {
    setDeleteConfirmationModal(true)

  }
  const deleteStream = async () => {
    try {
      setIsLoading(true)
      const response = await api.post(`/v1/recording/streaming/cancel?stream_filename=${streamfilename}`)
      if (response.status === 200) {
        stopRecording()
        setDeleteConfirmationModal(false)
        handlealertClick('Your Recording is Successfully cancelled', 'error')
      } else {
        setDeleteConfirmationModal(false)
      }
      if (blocker.current = true) {
        blocker.current = true
        stopmanualRecording()
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)

    }
  }
  return (<>

    <div className="flex items-center justify-center w-full h-auto"

    >
      <div className="w-[95%] mb-2 sm:w-[95%] flex flex-col justify-center items-center relative h-min-[150px] h-auto  p-8 pb-3 ">
        <div className='w-full relative flex flex-col gap-2 sm:flex-row sm:gap-0 justify-between items-center'>

          <div className='w-full flex justify-center items-center gap-4'>
            <div onClick={() => navigate(-1)} className="">
              <img src={arrowleft} alt="Down Arrow" className="w-5 h-5 cursor-pointer" />
            </div>
            <div
              className="relative flex justify-center items-center w-[70px] h-[70px] rounded-full"
              style={circleStyle}
            >
              <div className="flex justify-center items-center w-[60px] h-[60px] bg-[#FAFAF9] rounded-full">
                <img
                  src={userr?.profile_photo || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
                  alt='profile'
                  onError={(e) => e.target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
                  className="flex justify-center items-center w-[55px] h-[55px] bg-[#C4C4C4] rounded-full" />
              </div>

            </div>
            <div class="text-start font-sans font-medium">
              {userr?.patient_name ? <div class="text-sm text-gray-600">{userr?.patient_name}</div> : <></>}
              {userr?.patientid ? <div class="text-sm text-gray-600">{userr?.patientid}</div> : <></>}
              {userr?.dob ? (
                <div className="text-sm text-gray-600">
                  {new Date(userr.dob).toLocaleDateString('en-GB')}
                </div>
              ) : (
                <></>
              )}



            </div>
          </div>
          <div className='flex min-w-[600px] gap-4 items-end justify-center'>
            <div
              onClick={() => { handleCopyallText() }}
              className="flex flex-row h-auto sm:h-9  gap-2  items-center  cursor-pointer p-2 rounded-md border border-gray-100 bg-white shadow-[0px_4px_16px_0px_rgba(20,25,26,0.08)]">

              <img style={{ width: '13px', height: '13px' }} src={Copyall} alt="&/" />
              <div className="text-xs sm:text-sm"> Copy All</div>

            </div>
            <div className='flex flex-col gap-4 items-center justify-center'>


              {isIndRecord ? (
                <div>{!mydata.isStreaming ?
                  <IndividualRecording screenname={recordingField}
                    setIndIsRecording={setIndIsRecording}
                    submitIndAudio={submitIndAudio}
                    setToastmsg={setToastObject}
                    setToast={setToast}
                    setIsdelted={setIndIsDeletedAudio}
                  /> : <ArcheiveStreaming
                    setIsexitModal={setIsexitModal}
                    stopRecording={stopRecording}
                    elapsedTime={elapsedTime}
                    formatTime={formatTime}
                    togglePause={togglePause}
                    isPaused={isPaused}
                    setIsPaused={setIsPaused}
                    stopTimer={stopTimer}
                    pausedref={pausedref}
                    audioStreamRef={audioStreamRef}
                    onDelete={onDelete}
                  />}
                </div>
              ) : isRecording ? (
                !mydata.isStreaming ?
                  <ArchiveRecordingScreen
                    setIsRecording={setIsRecording}
                    submitAudio={submitAudio}
                    setToastmsg={setToastObject}
                    setToast={setToast}
                    setIsdelted={setIsdelted}
                  /> : <ArcheiveStreaming
                    setIsexitModal={setIsexitModal}
                    stopRecording={stopRecording}
                    elapsedTime={elapsedTime}
                    formatTime={formatTime}
                    togglePause={togglePause}
                    isPaused={isPaused}
                    setIsPaused={setIsPaused}
                    stopTimer={stopTimer}
                    pausedref={pausedref}
                    audioStreamRef={audioStreamRef}
                    onDelete={onDelete}
                  />
              ) : (
                <>
                  <div
                    onClick={() => {
                      if (mydata.isOpen) {
                        setAlertMessage('Recording already in progress');
                        setSeverity('info'); // Change severity as needed
                        setOpen(true);
                        return
                      }
                      if (mydata.isStreaming) {
                        startRecording()
                      }
                      setIsRecording(true);
                      setIsdelted(false);
                      handlealertClick('Recording Started');
                    }}
                    className="relative flex items-center justify-center"
                  >
                    <img src={redmic} className="w-[50px] h-[50px]" alt="Mic" />
                  </div>

                </>
              )}

            </div>

            <div
              onClick={() => navigate(`/modify-template/${id}`)}
              className="inline-flex h-auto sm:h-9  items-center cursor-pointer p-2 rounded-md border border-gray-100 bg-white shadow-[0px_4px_16px_0px_rgba(20,25,26,0.08)]">
              <img src={adveditpng} alt="Advanced Editing" className="mr-2" />
              <div className='text-xs sm:text-xs font-normal'>Advanced Editing</div>
            </div>

          </div>

          <div className='flex gap-4'>
            {data?.transcriptionstatus === 'Summarized' && (
              <button
                onClick={() => handleSignoff()}
                disabled={isbuttonloading}
                className={`px-6 py-2 rounded-lg text-white text-[10px] whitespace-nowrap ${isbuttonloading ? 'bg-gray-500 cursor-not-allowed opacity-50' : 'bg-[#1C2A3A] cursor-pointer opacity-100'
                  }`}
              >
                {isbuttonloading ? 'Signing Off...' : 'Sign Off'}
              </button>
            )}
            <button
              onClick={() => handletranscript()}
              disabled={isbuttonloading}
              className={`px-6 py-2 rounded-lg text-white text-[10px] whitespace-nowrap ${!true ? 'bg-gray-500 cursor-not-allowed opacity-50' : 'bg-[#1C2A3A] cursor-pointer opacity-100'
                }`}
            >
              Transcript
            </button>
            <div className='cursor-pointer' onClick={() => { handlepdf(data?.audiolink, data) }}>
              <LocalPrintshopIcon />

            </div>

          </div>



          <div className='flex w-full justify-end items-center'>
            <div className='flex items-center gap-4 sm:ml-14'>
              <DashboardOutlinedIcon
                onClick={() => setView(2)}
                style={{
                  color: view === 2 ? 'black' : 'grey', // Change the color based on isGridView
                  cursor: 'pointer',
                  fontSize: "26px"
                }}
              />
              <SplitscreenOutlinedIcon
                onClick={() => setView(1)}
                style={{
                  color: view === 1 ? 'black' : 'grey', // Change the color based on isGridView
                  cursor: 'pointer',
                  fontSize: "26px"
                }}
              />
              <MenuIcon
                onClick={() => { setView(0) }}
                style={{
                  color: view === 0 ? 'black' : 'grey', // Change the color based on isGridView
                  cursor: 'pointer',
                  fontSize: "30px"
                }}
              />


            </div>
          </div>


        </div>
        {view === 0 ?
          <div className='w-full mt-[4%] items-center justify-center flex flex-col gap-4'>
            {jsonData.map((section, idx) => (
              <>
                {summaryjson?.[section.placeholder?.toLowerCase()]?.length > 0 ?
                  <div
                    onClick={() => {
                      setSectionData(section)
                      setPopUp(true)
                    }}

                    key={idx} className="flex flex-col cursor-pointer sm:flex-row justify-between items-center w-full sm:w-[80%] h-auto sm:h-20 rounded-lg shadow-md pr-0 sm:pr-4 border-l-4 border-[#A2C6FD] border-t border-b border-t-gray-400 border-b-gray-400 bg-white">
                    <div className="flex items-center justify-center w-full sm:w-[20%] sm:min-w-[20%] sm:max-w-[20%] h-full bg-blue-100 p-0 rounded-md">
                      <h1 className="text-sm font-bold text-blue-600">{section.label
                        ? section.label
                          .toLowerCase() // Ensure all letters are lowercase first
                          .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
                        : ''}</h1>
                    </div>
                    <div className='w-full flex justify-start'>

                      <div
                        className="mt-2 font-sans text-[#374151] px-4 text-left"
                        dangerouslySetInnerHTML={{
                          __html: summaryjson?.[section.placeholder?.toLowerCase()]?.length > 50
                            ? `${summaryjson[section.placeholder?.toLowerCase()].substring(0, 50)}...`.replace(/\n/g, '<br />')
                            : summaryjson[section.placeholder?.toLowerCase()]?.replace(/\n/g, '<br />')
                        }}
                      ></div>

                    </div>


                    <div className='flex gap-4 justify-end items-center w-full sm:min-w-[20%] sm:max-w-[20%]'>
                      {['review of systems', 'physical examination'].includes(section.label) ? (
                        <div className={`inline-block px-3 py-1 text-xs rounded-full shadow-md ${summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ? 'text-green-700 bg-green-200' : 'text-red-700 bg-red-200'}`}>
                          {summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ? 'Normal' : 'Abnormal'}
                        </div>
                      ) : null}

                      <div className='flex gap-4 items-center justify-center flex-row '>
                        {section?.label === 'doctor instructions' ? <ShareOutlinedIcon
                          onClick={(event) => {
                            event.stopPropagation(); // Prevent event from bubbling up
                            setSelectedCard(section);
                            setIsShareModal(true);
                          }}
                          sx={{
                            fontSize: "18px",
                            color: "#676767",
                            cursor: "pointer",
                            marginTop: "2rem",
                          }}
                        />
                          : <></>}
                        <FontAwesomeIcon
                          onClick={() => {
                            setSectionData(section)
                            setFields(prevFields => ({ ...prevFields, [section.key]: formatToText(section.value) }))

                            setPopUp(true)
                          }}
                          icon={faUpRightFromSquare} className="text-[#7E7E7E] mt-8 cursor-pointer" />


                      </div>
                    </div>

                  </div>
                  : <></>}
              </>
            ))
            }</div> :
          (view === 1 ?
            <>
              <div className="w-full mt-[4%] flex flex-col justify-center gap-4">

                {jsonData.map((section, idx) => (
                  <>{
                    summaryjson?.[section.placeholder?.toLowerCase()]?.length > 0 ?
                      <div
                        key={idx}
                        className="flex flex-col justify-between items-center w-auto max-w-full"
                        style={{
                          borderRadius: "8px",
                          border: "1px solid rgba(162, 198, 253, 0.40)",
                          background: "#FFF",
                          boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
                          flex: '1 0 auto', // Ensures it grows dynamically
                        }}
                      >
                        <div className="flex items-center justify-between w-full h-10 px-4 bg-blue-100 p-0 rounded-md">
                          <h1 className="text-sm font-bold text-[#262629]">
                            {section.label
                              ? section.label
                                .toLowerCase() // Ensure all letters are lowercase first
                                .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
                              : ''}
                          </h1>
                          <div className='flex gap-4 items-center'>
                            {section?.label === 'doctor instructions' ? <ShareOutlinedIcon
                              onClick={() => {
                                setSelectedCard(section)
                                setIsShareModal(true)
                              }}
                              sx={{ fontSize: "18px", color: "#676767", cursor: "pointer" }}
                            /> : <></>}


                            <FontAwesomeIcon
                              onClick={() => {
                                setSectionData(section)
                                setFields(prevFields => ({ ...prevFields, [section.key]: formatToText(section.value) }))
                                setPopUp(true);

                              }}
                              icon={faUpRightFromSquare} className="text-[#7E7E7E] cursor-pointer" />
                          </div>
                        </div>
                        <div className="w-full flex justify-start">
                          <div
                            className="mt-2 font-sans text-[#374151] px-4 text-left"
                            dangerouslySetInnerHTML={{
                              __html: summaryjson?.[section.placeholder?.toLowerCase()]?.length > 100
                                ? `${summaryjson[section.placeholder?.toLowerCase()].substring(0, 100)}...`.replace(/\n/g, '<br />')
                                : summaryjson[section.placeholder?.toLowerCase()]?.replace(/\n/g, '<br />')
                            }}
                          ></div>
                        </div>
                        <div className="flex mb-4 justify-end items-center w-full px-4">
                          {['review of systems', 'physical examination'].includes(section.label) ? (
                            <div className={`inline-block px-3 py-1 text-xs rounded-full shadow-md ${summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ? 'text-green-700 bg-green-200' : 'text-red-700 bg-red-200'}`}>
                              {summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ? 'Normal' : 'Abnormal'}
                            </div>
                          ) : null}
                        </div>
                      </div> : <></>
                  }</>
                ))}

              </div>




            </> : <>
              <div className="w-full mt-[4%] grid  grid-cols-1 sm:grid-cols-3 gap-4">
                {jsonData.map((section, idx) => {
                  let customClasses = "";

                  // Determine layout based on repeating pattern
                  const positionInPattern = idx % 7; // Pattern repeats every 7 items

                  if (positionInPattern === 0 || positionInPattern === 1 || positionInPattern === 2) {
                    // First row: 3 equal-width boxes
                    customClasses = " col-span-3 sm:col-span-1 min-h-[120px]";
                  } else if (positionInPattern === 3) {
                    // Second row: 1 full-width box
                    customClasses = "col-span-3 min-h-[120px]";
                  } else if (positionInPattern === 4) {
                    // Third row: less-width box
                    customClasses = " col-span-3 sm:col-span-1 min-h-[120px]";
                  } else if (positionInPattern === 5) {
                    // Third row: more-width box
                    customClasses = "col-span-3 sm:col-span-2 min-h-[120px]";
                  } else if (positionInPattern === 6) {
                    // Fourth row: full-width box
                    customClasses = "col-span-3 min-h-[120px]";
                  }

                  return (<>{
                    summaryjson?.[section.placeholder?.toLowerCase()]?.length > 0 ?
                      <div
                        key={idx}
                        className={`flex flex-col justify-start items-start w-auto max-w-full ${customClasses}`}
                        style={{
                          borderRadius: "8px",
                          border: "1px solid rgba(162, 198, 253, 0.40)",
                          background: "#FFF",
                          boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05)",
                          flex: "1 0 auto",
                        }}
                      >
                        <div className="flex items-center justify-between w-full h-10 px-4 bg-blue-100 p-0 rounded-md">
                          <h1 className="text-sm font-bold text-[#262629]">
                            {section.label
                              ? section.label
                                .toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase())
                              : ""}
                          </h1>
                          <div className='flex items-center gap-4'>

                            {section?.label === 'doctor instructions' ? <ShareOutlinedIcon
                              onClick={() => {
                                setSelectedCard(section)

                                setIsShareModal(true)
                              }}
                              sx={{ fontSize: "18px", color: "#676767", cursor: "pointer" }}
                            /> : <></>}
                            <FontAwesomeIcon
                              onClick={() => {
                                setSectionData(section);
                                setFields(prevFields => ({ ...prevFields, [section.key]: formatToText(section.value) }))
                                setPopUp(true);
                              }}
                              icon={faUpRightFromSquare}
                              className="text-[#7E7E7E] cursor-pointer"
                            />
                          </div>

                        </div>
                        <div className="w-full flex justify-start">
                          <div
                            className="mt-2 font-sans text-[#374151] px-4 text-left"
                            dangerouslySetInnerHTML={{
                              __html: summaryjson?.[section.placeholder?.toLowerCase()]?.length > 100
                                ? `${summaryjson[section.placeholder?.toLowerCase()].substring(0, 100)}...`.replace(/\n/g, '<br />')
                                : summaryjson[section.placeholder?.toLowerCase()]?.replace(/\n/g, '<br />')
                            }}
                          ></div>
                        </div>
                        <div className="flex mb-4 justify-end items-center w-full px-4">
                          {['review of systems', 'physical examination'].includes(section.label) ? (
                            <div className={`inline-block px-3 py-1 text-xs rounded-full shadow-md ${summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ? 'text-green-700 bg-green-200' : 'text-red-700 bg-red-200'}`}>
                              {summaryjson[section.placeholder?.toLowerCase()].replace(/\s|\./g, '') === 'Normal' ? 'Normal' : 'Abnormal'}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      : <></>} </>
                  );
                })}
              </div>






            </>
          )
        }

        {/* <div className='w-full flex justify-center  flex-col items-center'>
        <div className="mt-[6%] w-[90%] grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
        {jsonData.map((section, idx) => (
     <div
     key={idx}
     className="flex shadow-[0px_2px_13px_#00000040] flex-col p-4 gap-2 w-full max-w-[350px]"
     style={{
       borderRadius: "8px",
       background: "#FFF",
   
     }}
   >
          <div className="flex justify-between w-full">
            <div style={{ fontWeight: 500 }} className="text-xs">{section.label}</div>          
          </div>
          <div className="relative">
          <textarea
  className="w-full custom-scrollbar  max-w-md p-2 font-inter placeholder:text-xs"
  style={{
    borderRadius: "8px",
    border: "1px solid #A2C6FD",
    background: "#FFF",
    boxShadow: "0px 5px 15px 0px rgba(119, 132, 238, 0.30)",
  }}
  rows={8}
  value={fields[section.key]}
  onChange={(e) => handleFieldChange(section.key, e.target.value)}
  placeholder={section.placeholder}
/>
            <div className="absolute right-2 bottom-2">
            
            </div>
          </div>
<div className='w-full flex justify-between items-center'>
<div className='flex items-center gap-4'>
<div>
                <img
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  src={copydark}
                  alt="Copy"
                  onClick={() => copyToClipboard(fields[section.key])}
                />
              </div>
              <div>
                <img
                  style={{ width: "13px", height: "13px", cursor: "pointer" }}
                  src={printdark}
                  alt="Print"
                  onClick={() => {
                    if (data.transcriptionstatus === 'Processing') {
                      setAlertMessage('Update in process. Hold on!');
                      setSeverity('info'); 
                      setOpen(true);
                      return;
                    }
                    handleSaveIconClick(section.key)}}
                />
              </div>

</div>

<div className="flex items-center gap-2">
              <div   onClick={()=>{
                    if(recordingField==section.key){
                      return
                    }
                    if(recordingField){
                      return
                    }
                    if (data.transcriptionstatus === 'Processing') {
                      setAlertMessage('Update in process. Hold on!');
                      setSeverity('info'); 
                      setOpen(true);
                      return;
                    }
                    if(mydata.isOpen){
                      setAlertMessage('Recording already in progress');
                      setSeverity('info'); 
                      setOpen(true);
                    return
                    }
                    setRecordingField(section.key)
                    setIsIndRecord(true)
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }} 
                   >
                 <MicIcon 
  fontSize="small" 
  style={{ 
    cursor: "pointer", 
    width: "20px", 
    height: "20px", 
    color: recordingField === section.key ? 'red' : '#000' 
  }} 
/>

              
              </div>
          
            </div>

</div>

        </div>
      ))}

    </div>
</div> */}
        <div className="flex flex-wrap items-center p-4 mt-6 justify-center gap-4">


          <button
            onClick={handleSaveButtonClick}
            className="px-16 py-2 rounded-full bg-[#1C2A3A] font-[Tahoma] text-white text-xs"
          >
            Save
          </button>

          {/* {data?.transcriptionstatus==='Summarized'?<>
            <button
      onClick={()=>{handleSignoff()}}
      disabled={isbuttonloading} // Disable the button during loading
      className={`px-16 py-2 rounded-full text-white  text-xs ${
        isbuttonloading ? 'bg-gray-500 cursor-not-allowed opacity-50' : 'bg-[#1C2A3A] cursor-pointer opacity-100'
      }`}
    >
      {isbuttonloading ? 'Signing Off...' : 'Sign Off'}
    </button>
          
          
          </>:<></>} */}
        </div>
      </div>
    </div>


    {popup ? (
      <>
        {/* Dark Background Overlay */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50"
          onClick={() => setPopUp(false)} // Close popup on clicking outside
        ></div>

        {/* Popup Content */}
        <div
          className="flex flex-col h-full shadow-[0px_2px_13px_#00000040] p-4 gap-2 w-full max-w-[550px] sm:max-w-[60%] sm:min-h-[400px] sm:h-[80vh]  sm:max-h-[90vh] bg-white fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
          style={{
            borderRadius: "8px",
            background: "white",
            // height: "80vh", // Fixed height
            // maxHeight: "90vh", // Prevents overflow on smaller screens
            overflow: "hidden", // Prevents popup from growing beyond fixed height
          }}
        >
          {/* Section Label */}
          <div className="flex justify-between w-full mb-4">
            <div style={{ fontWeight: 500 }} className="text-sm">
              {sectiondata.label
                ? sectiondata.label
                  .toLowerCase()
                  .replace(/\b\w/g, (char) => char.toUpperCase())
                : ""}
            </div>

            {/* {["review of systems", "physical examination"].includes(
          sectiondata.label
        ) ? (
          <div className="inline-block px-3 py-1 text-xs text-[#991B1B] bg-[#FEE2E2] rounded-full shadow-md">
            {summaryjson?.[sectiondata.placeholder]?.length
              ? "Abnormal"
              : "Normal"}
          </div>
        ) : null} */}

            <CloseIcon
              style={{ cursor: "pointer", color: "#000" }}
              onClick={() => setPopUp(false)}
            />
          </div>

          {/* Textarea */}
          <div className="h-full flex-grow overflow-hidden">
            {/* <textarea
          className="w-full h-full custom-scrollbar max-w-[90%] p-2 font-inter placeholder:text-xs"
          style={{
            borderRadius: "8px",
            border: "1px solid #A2C6FD",
            background: "#FFF",
            boxShadow: "0px 5px 15px 0px rgba(119, 132, 238, 0.30)",
          }}
          rows={12}
          value={fields[sectiondata.key]}
          onChange={(e) => handleFieldChange(sectiondata.key, e.target.value)}
          placeholder={sectiondata.placeholder}
        />  */}
            <ReactQuill
              className="w-full text-start flex-grow custom-scrollbar p-2 font-inter"
              style={{
                borderRadius: "8px",
                border: "1px solid #A2C6FD",
                background: "#FFF",
                boxShadow: "0px 5px 15px 0px rgba(119, 132, 238, 0.30)",
                minHeight: "200px",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden"
              }}
              value={fields[sectiondata.key]?.replace(/\n/g, "<br/>")}
              onChange={(value) => handleFieldChange(sectiondata.key, value)}
              placeholder={sectiondata.placeholder}
              modules={{
                toolbar: [
                  [{ font: [] }], // Font family dropdown
                  [{ size: ["small", false, "large", "huge"] }], // Font size
                  [{ header: [1, 2, 3, 4, 5, 6, false] }], // Headers
                  ["bold", "italic", "underline", "strike"], // Text styles
                  [{ color: [] }, { background: [] }], // Text color and background
                  [{ script: "sub" }, { script: "super" }], // Subscript & Superscript
                  [{ list: "ordered" }, { list: "bullet" }], // Lists
                  [{ indent: "-1" }, { indent: "+1" }], // Indentation
                  [{ align: [] }], // Text alignment
                  ["blockquote", "code-block"], // Blockquote & Code block
                  // ["link", "image", "video"], // Media embeds
                  ["clean"], // Clear formatting
                ],
              }}
              formats={[
                "font", "size", "header",
                "bold", "italic", "underline", "strike",
                "color", "background",
                "script", "sub", "super",
                "list", "bullet", "indent",
                "align", "blockquote", "code-block",
                // "link", "image", "video"
              ]}
            />
          </div>

          {/* Footer Section */}
          <div className="w-full flex justify-between items-center">
            <div className="flex items-center gap-4">
              {/* Copy Icon */}
              <div>
                <img
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  src={copydark}
                  alt="Copy"
                  onClick={() => copyToClipboard(fields[sectiondata.key])}
                />
              </div>

              {/* Print Icon */}
              <div>
                <img
                  style={{ width: "13px", height: "13px", cursor: "pointer" }}
                  src={printdark}
                  alt="Print"
                  onClick={() => {
                    if (data.transcriptionstatus === "Processing") {
                      setAlertMessage("Update in process. Hold on!");
                      setSeverity("info");
                      setOpen(true);
                      return;
                    }

                    handleSaveIconClick(sectiondata.key);
                  }}
                />
              </div>
            </div>

            {/* Mic Icon */}
            <div className="flex items-center gap-2">
              <div
                onClick={() => {
                  if (recordingField === sectiondata.key) {
                    return;
                  }
                  if (recordingField) {
                    return;
                  }
                  if (data.transcriptionstatus === "Processing") {
                    setAlertMessage("Update in process. Hold on!");
                    setSeverity("info");
                    setOpen(true);
                    return;
                  }
                  if (mydata.isOpen) {
                    setAlertMessage("Recording already in progress");
                    setSeverity("info");
                    setOpen(true);
                    return;
                  }
                  setRecordingField(sectiondata.key);
                  setIsIndRecord(true);
                  indref.current = true
                  recordingfieldref.current = sectiondata.key
                  if (mydata.isStreaming) {
                    startRecording(sectiondata.key)
                  }
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  setPopUp(false);
                }}
              >
                <MicIcon
                  fontSize="small"
                  style={{
                    cursor: "pointer",
                    width: "20px",
                    height: "20px",
                    color: recordingField === sectiondata ? "red" : "#000",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    ) : (
      <></>
    )}
    {/* Copy feedback message */}
    <Snackbar
      open={copyFeedback}
      autoHideDuration={3000}
      // onClose={handleClose}
      message="Copied to clipboard!"
    // action={action}
    />
    {showtranscript ? <TranscriptModal handlealertClick={handlealertClick} popup={showtranscript} text={transciptFile} setmodal={setShowTranscript} handleEditTranscript={handleEditTranscript} /> : <></>}
    <ToastModal toastobject={toastobject} isModalOpen={toast} setModalOpen={setToast} />
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
      <CircularProgress color="inherit" />
    </Backdrop>
    <PdfRender ispdfshow={ispdfshow} setIspdfShow={setIspdfShow} pdfBlob={pdffile} data={mycard} />
    <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
    <ExitModal savemodal={isExitModal} setModalOpen={setIsexitModal} onExit={onExit} />
    <DeleteConfirmation savemodal={deleteconfirmationModal} setModalOpen={setDeleteConfirmationModal} onExit={deleteStream} />
    <ShareModal
      setSeverity={setSeverity}
      data={data}
      setAlertMessage={setAlertMessage}
      setOpen={setOpen}
      selectedCard={selectedCard} isOpen={isSharemodal} onClose={setIsShareModal} />
  </>
  );
};

export default Editscreen;
